import { AngularSvgIconModule } from "angular-svg-icon";

import { ChangeDetectionStrategy, Component, computed, input } from "@angular/core";

import { IpBgpSubscriptionDetails } from "../../../pages/subscription-detail/types";

type BgpSap = IpBgpSubscriptionDetails["saps"][number];

@Component({
  selector: "bgp-sap-summary-row",
  templateUrl: "bgp-sap-summary-row.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [AngularSvgIconModule],
})
export class BgpSapSummaryRow {
  readonly sap = input.required<BgpSap>();
  readonly index = input.required<number>();
  readonly initialPriority = input.required<string | null | undefined>();

  protected customerDescription = computed(() => this.sap().port?.customerDescription);
  protected bgpSessionPriority = computed(() => this.sap().bgpSessionPriority);
  protected hasChanged = computed(() => this.initialPriority() !== this.bgpSessionPriority());
}
